export default __webpack_public_path__ + "static/f26-04528f04819a654f78077790e82ed125.svg";